import { ReactNode } from "react";

type Props = {
  title: string;
  desc?: string;
  actions?: ReactNode;
};

export function SectionHeader({ title, desc, actions }: Props) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: 12,
        marginBottom: 16,
        flexWrap: "wrap",
      }}
    >
      <div>
        <h2
          className="display"
          style={{ fontSize: 22, margin: 0, color: "var(--brand-900)", fontWeight: 400 }}
        >
          {title}
        </h2>
        {desc && (
          <div
            style={{ fontSize: 13, color: "var(--fg-muted)", marginTop: 4, maxWidth: 560 }}
          >
            {desc}
          </div>
        )}
      </div>
      {actions && <div style={{ display: "flex", gap: 8 }}>{actions}</div>}
    </div>
  );
}
